<!--
  找回密码
  lovi 2020-07-11
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('common.retrievePassword')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />
    <div class="scroll-wrapper">
      <scroll>
        <van-cell-group>
          <van-cell
            :title="$t('logReg.MailboxBound')"
            :label="$t('logReg.emailResetPsd')"
            @click="_linkFun('/retrievePath?flag=0')"
            is-link
          />
          <van-cell
            :title="$t('logReg.securitySet')"
            :label="$t('logReg.securityResetPsd')"
            @click="_linkFun('/retrievePath?flag=1')"
            is-link
          />
        </van-cell-group>
      </scroll>
    </div>
  </div>
</template>

<script>
export default {
  name: "retrievePsd",
  meta: {
    power: false, // 权限
    service: false // 客服
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
  watch: {}
};
</script>

<style lang="less" scoped>
/deep/.van-cell {
  align-items: center;
}
</style>
